import { c as _c } from "react/compiler-runtime";
import { Drawer, DrawerContent } from "@repo/ui/components/ui/drawer";
import { useIsMobile } from "@repo/ui/hooks/use-mobile";
import { cn } from "@repo/ui/lib/utils";
import { MapPin } from "lucide-react";
import { MapContainer } from "@/lib/components/map/Map";
import { PlaceDetail } from "@/lib/components/map/PlaceDetail";
import { useKartaView } from "@/lib/hooks/useKartaView";
import { getCategoryIcon } from "@/lib/utils/categoryIcons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function KartaView() {
  const $ = _c(27);
  const isMobile = useIsMobile();
  const k = useKartaView();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      key: "alla",
      label: "Alla"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      key: "kartlagda",
      label: "Kartlagda"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      key: "vantar",
      label: "V\xE4ntar"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [t0, t1, t2, {
      key: "bidra",
      label: "Beh\xF6ver bidrag"
    }];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const filterChips = t3;
  let t4;
  if ($[4] !== k.clearSelection || $[5] !== k.flyToRef || $[6] !== k.places || $[7] !== k.selectPlace || $[8] !== k.selectedPlaceId) {
    t4 = /*#__PURE__*/_jsx("div", {
      className: "absolute inset-0",
      children: /*#__PURE__*/_jsx(MapContainer, {
        places: k.places,
        usePmtiles: true,
        selectedPlaceId: k.selectedPlaceId,
        onSelectPlace: k.selectPlace,
        onClearSelection: k.clearSelection,
        flyToRef: k.flyToRef
      })
    });
    $[4] = k.clearSelection;
    $[5] = k.flyToRef;
    $[6] = k.places;
    $[7] = k.selectPlace;
    $[8] = k.selectedPlaceId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== k) {
    t5 = /*#__PURE__*/_jsx("div", {
      className: "absolute left-3 top-3 z-10 flex gap-1.5 md:hidden",
      children: filterChips.map(t6 => {
        const {
          key,
          label
        } = t6;
        return /*#__PURE__*/_jsx("button", {
          onClick: () => k.setAccessFilter(key),
          className: cn("rounded-full px-3 py-1.5 text-xs font-medium shadow-sm transition-colors", k.accessFilter === key ? "bg-brand text-white shadow-brand/20" : "bg-white text-gray-600 hover:bg-gray-100"),
          children: label
        }, key);
      })
    });
    $[10] = k;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== k) {
    t6 = /*#__PURE__*/_jsx("div", {
      className: "flex gap-1.5 border-b px-4 py-3",
      children: filterChips.map(t7 => {
        const {
          key: key_0,
          label: label_0
        } = t7;
        return /*#__PURE__*/_jsx("button", {
          onClick: () => k.setAccessFilter(key_0),
          className: cn("rounded-full px-3 py-1.5 text-xs font-medium transition-colors", k.accessFilter === key_0 ? "bg-brand text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"),
          children: label_0
        }, key_0);
      })
    });
    $[12] = k;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== k) {
    t7 = /*#__PURE__*/_jsx("div", {
      className: "flex-1 overflow-y-auto",
      children: k.selectedPlaceId ? /*#__PURE__*/_jsx(PlaceDetail, {
        placeId: k.selectedPlaceId,
        onClose: k.clearSelection,
        onReport: (id, name) => k.openReport(id, name)
      }, k.selectedPlaceId) : /*#__PURE__*/_jsx(PlaceList, {
        places: k.places,
        onSelect: k.selectPlace,
        isFetching: k.isFetching
      })
    });
    $[14] = k;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = /*#__PURE__*/_jsxs("div", {
      className: "absolute left-0 top-0 bottom-0 z-10 hidden w-96 flex-col border-r bg-white md:flex",
      children: [t6, t7]
    });
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== isMobile || $[20] !== k) {
    t9 = isMobile && /*#__PURE__*/_jsx(Drawer, {
      open: !!k.selectedPlaceId,
      onOpenChange: open => {
        if (!open) {
          k.clearSelection();
        }
      },
      children: /*#__PURE__*/_jsx(DrawerContent, {
        className: "max-h-[85vh]",
        children: /*#__PURE__*/_jsx("div", {
          className: "overflow-y-auto pb-[env(safe-area-inset-bottom)]",
          children: k.selectedPlaceId && /*#__PURE__*/_jsx(PlaceDetail, {
            placeId: k.selectedPlaceId,
            onClose: k.clearSelection,
            onReport: (id_0, name_0) => k.openReport(id_0, name_0)
          }, k.selectedPlaceId)
        })
      })
    });
    $[19] = isMobile;
    $[20] = k;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t4 || $[23] !== t5 || $[24] !== t8 || $[25] !== t9) {
    t10 = /*#__PURE__*/_jsxs("div", {
      className: "relative h-[calc(100dvh-3.5rem-env(safe-area-inset-top))]",
      children: [t4, t5, t8, t9]
    });
    $[22] = t4;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}

// ─── Place list ─────────────────────────────────────────────────────────────

function PlaceListSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx("div", {
      className: "animate-pulse",
      children: Array.from({
        length: 8
      }).map(_temp)
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, i) {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex items-center gap-3 border-b px-4 py-3",
    children: [/*#__PURE__*/_jsx("div", {
      className: "h-8 w-8 shrink-0 rounded-full bg-gray-200"
    }), /*#__PURE__*/_jsxs("div", {
      className: "min-w-0 flex-1 space-y-1.5",
      children: [/*#__PURE__*/_jsx("div", {
        className: "h-3.5 w-3/4 rounded bg-gray-200"
      }), /*#__PURE__*/_jsx("div", {
        className: "h-3 w-1/2 rounded bg-gray-100"
      })]
    })]
  }, i);
}
function PlaceList(t0) {
  const $ = _c(11);
  const {
    places,
    onSelect,
    isFetching
  } = t0;
  if (places.length === 0 && isFetching) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx(PlaceListSkeleton, {});
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (places.length === 0) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx("div", {
        className: "flex items-center justify-center py-12 text-gray-400",
        children: /*#__PURE__*/_jsxs("div", {
          className: "text-center",
          children: [/*#__PURE__*/_jsx(MapPin, {
            className: "mx-auto mb-2 h-8 w-8"
          }), /*#__PURE__*/_jsx("p", {
            className: "text-sm",
            children: "Inga platser i detta omr\xE5de"
          })]
        })
      });
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  let t2;
  let t3;
  if ($[2] !== onSelect || $[3] !== places) {
    const verified = places.filter(_temp2);
    const pending = places.filter(_temp3);
    const unverified = places.filter(_temp4);
    t1 = verified.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("p", {
        className: "px-4 pb-1 pt-3 text-xs font-medium uppercase tracking-wider text-green-600",
        children: ["Kartlagda (", verified.length, ")"]
      }), verified.map(place => /*#__PURE__*/_jsx(PlaceRow, {
        place: place,
        onSelect: onSelect
      }, place.id))]
    });
    t2 = pending.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("p", {
        className: "px-4 pb-1 pt-3 text-xs font-medium uppercase tracking-wider text-amber-500",
        children: ["V\xE4ntar p\xE5 granskning (", pending.length, ")"]
      }), pending.map(place_0 => /*#__PURE__*/_jsx(PlaceRow, {
        place: place_0,
        onSelect: onSelect
      }, place_0.id))]
    });
    t3 = unverified.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("p", {
        className: "px-4 pb-1 pt-3 text-xs font-medium uppercase tracking-wider text-gray-400",
        children: ["Beh\xF6ver bidrag (", unverified.length, ")"]
      }), unverified.map(place_1 => /*#__PURE__*/_jsx(PlaceRow, {
        place: place_1,
        onSelect: onSelect
      }, place_1.id))]
    });
    $[2] = onSelect;
    $[3] = places;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = /*#__PURE__*/_jsxs("div", {
      children: [t1, t2, t3]
    });
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp4(p_1) {
  return !p_1.hasVerifiedFeature && !p_1.hasPendingFeature;
}
function _temp3(p_0) {
  return p_0.hasPendingFeature && !p_0.hasVerifiedFeature;
}
function _temp2(p) {
  return p.hasVerifiedFeature;
}
function PlaceRow(t0) {
  const $ = _c(26);
  const {
    place,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== place.categoryIcon) {
    t1 = getCategoryIcon(place.categoryIcon);
    $[0] = place.categoryIcon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const Icon = t1;
  const isVerified = place.hasVerifiedFeature;
  const isPending = place.hasPendingFeature && !isVerified;
  let t2;
  if ($[2] !== onSelect || $[3] !== place.id) {
    t2 = () => onSelect(place.id);
    $[2] = onSelect;
    $[3] = place.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isVerified ? "bg-green-100" : isPending ? "bg-amber-100" : "bg-slate-100";
  let t4;
  if ($[5] !== t3) {
    t4 = cn("flex h-8 w-8 shrink-0 items-center justify-center rounded-full", t3);
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = isVerified ? "text-green-600" : isPending ? "text-amber-500" : "text-slate-500";
  let t6;
  if ($[7] !== t5) {
    t6 = cn("h-4 w-4", t5);
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== Icon || $[10] !== t6) {
    t7 = /*#__PURE__*/_jsx(Icon, {
      className: t6
    });
    $[9] = Icon;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = /*#__PURE__*/_jsx("div", {
      className: t4,
      children: t7
    });
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== place.name) {
    t9 = /*#__PURE__*/_jsx("span", {
      className: "block truncate text-sm font-medium text-gray-900",
      children: place.name
    });
    $[15] = place.name;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== place.categoryName) {
    t10 = place.categoryName && /*#__PURE__*/_jsx("span", {
      className: "block truncate text-xs text-gray-500",
      children: place.categoryName
    });
    $[17] = place.categoryName;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = /*#__PURE__*/_jsxs("div", {
      className: "min-w-0",
      children: [t9, t10]
    });
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t2 || $[24] !== t8) {
    t12 = /*#__PURE__*/_jsxs("button", {
      onClick: t2,
      className: "flex w-full items-center gap-3 border-b px-4 py-3 text-left transition-colors hover:bg-gray-50",
      children: [t8, t11]
    });
    $[22] = t11;
    $[23] = t2;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}